import create from 'zustand';
import { combine } from 'zustand/middleware';

const useRenewal = create(
  combine<any, any>(
    {
      homeRenewalEntry: {},
      cuRemaining: {},
      studentType: {},
    },
    (set) => ({
      setHomeRenewalEntry: (homeRenewalEntry: any) => {
        set(() => ({ homeRenewalEntry }));
      },
      setCuRemaining: (cuRemaining: any) => {
        set(() => ({ cuRemaining }));
      },
      setStudentType: (studentType: any) => {
        set(() => ({ studentType }));
      },
    }),
  ),
);

export default useRenewal;
